import React, { useState, useEffect, useRef } from "react";
import { Input, Checkbox, Button, Spin } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { detectWebDeviceType } from "../../utils";

const NewGroup_Modal = ({ open, onClose, onSave, groupLoading }) => {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();
  // const deviceType = 'tablet';

  const [englishName, setEnglishName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
const dropdownRef = useRef(null);
const toggleBtnRef = useRef(null);
  const userData = useSelector((state) => state?.login?.user?.result);


  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      toggleBtnRef.current &&
      !toggleBtnRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }
  };

  if (showDropdown) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showDropdown]);


  // Fetch products
  const getProducts = async (val = "") => {
    setLoading(true);
    try {
      const payload = {
        company_id: userData?.company_id,
        product_name: val,
        barcode: "",
        limit: 10,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await axiosInstance.post(URLS.GET_PRODUCT_SEARCH, payload);
      const result = res?.data?.result?.[0]?.response || [];
      setProducts(result);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) getProducts();
  }, [open]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length === 0 || searchQuery.length > 2)
        getProducts(searchQuery);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const toggleProduct = (id) => {
    setSelectedProducts((prev) =>
      prev.includes(id)
        ? prev.filter((pid) => pid !== id)
        : [...prev, id]
    );
  };

  const handleClose = () => {
    setEnglishName("");
    setArabicName("");
    setSearchQuery("");
    setSelectedProducts([]);
    setShowDropdown(false);
    onClose?.();
  };

  const handleSave = () => {

    if (englishName.trim() === "" || arabicName.trim() === "") {
      toast.error(t("Please enter both English and Arabic group names."));
      return;
    }

    // if (selectedProducts.length === 0) {
    //   toast.error(t("Please select at least one product."));
    //   return;
    // }
    onSave?.({
      englishName,
      arabicName,
      selectedProducts,
    });
    // handleClose();
  };

  if (!open) return null; // hide modal when closed

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
    >
      {groupLoading && <LoadingSpinner />}

      {/* Modal container */}
      <div className={`relative  bg-white rounded-[20px] p-10 shadow-2xl animate-fadeIn ${deviceType == 'tablet' ? 'w-[1200px]' : "w-[900px]"}`}>
        {/* Close Button (optional) */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl font-semibold"
        >
          ×
        </button>

        {/* Title */}
        <h2 className="text-3xl font-bold mb-6">{t("Create New Group")}</h2>
<div className={`${deviceType == 'tablet' ? 'flex justify-between gap-x-6 items-end' : ""}`}>
        <div className={`mb-8 ${deviceType == 'tablet' ? 'w-1/2' : ""}`}>
          <h3 className="text-xl font-semibold mb-4 text-gray-600">
            {t("Group Name")}
          </h3>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-lg mb-2 font-medium text-gray-600">{t("English")}</label>
              <Input
                size="large"
                placeholder={t("Enter group name")}
                value={englishName}
                // onChange={(e) => setEnglishName(e.target.value)}
                // onChange={(e) => {
                //   const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, ""); // only letters, numbers & spaces
                //   setEnglishName(val);
                // }}
                // onChange={(e) => {
                //   const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                //   setEnglishName(val.trimStart()); // trims leading space
                // }}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^\u0600-\u06FFa-zA-Z0-9\s]/g, ""); // Allow Arabic letters, Latin letters, numbers, and spaces
                  setEnglishName(val.trimStart()); // Trims leading spaces
                }}
                maxLength={25}

                onBlur={() => setEnglishName((prev) => prev.trim())} // trims both ends on blur
                className="rounded-md h-12 text-lg"
              />
            </div>
            <div>
              <label className="block text-lg mb-2 font-medium text-gray-600">{t("Arabic")}</label>
              <Input
                size="large"
                placeholder="أدخل اسم المجموعة"
                value={arabicName}
                // onChange={(e) => setArabicName(e.target.value)}
                // onChange={(e) => {
                //   const val = e.target.value.replace(/[^\u0600-\u06FF0-9\s]/g, ""); // Arabic letters, numbers, spaces
                //   setArabicName(val);
                // }}
                // onChange={(e) => {
                //   const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                //   setArabicName(val.trimStart()); // trims leading space
                // }}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^\u0600-\u06FFa-zA-Z0-9\s]/g, ""); // Allow Arabic letters, Latin letters, numbers, and spaces
                  setArabicName(val.trimStart()); // Trims leading spaces
                }}
                maxLength={25}

                onBlur={() => setArabicName((prev) => prev.trim())} // trims both ends on blur
                dir="rtl"
                className="rounded-md h-12 text-lg"
              />
            </div>
          </div>
        </div>

        {/* Product Dropdown Section */}
        <div className={`mb-8 relative ${deviceType == 'tablet' ? 'w-1/2' : ""}`}>
          <label className="block text-xl mb-2 font-semibold text-gray-600">
            {t("Product List")}
          </label>

          <button
            ref={toggleBtnRef}
            onClick={() => setShowDropdown(!showDropdown)}
            className="w-full flex items-center justify-between border border-gray-300 rounded-md h-12 px-4 text-lg focus:outline-none"
          >
            <span>
              {selectedProducts.length > 0
                ? `${selectedProducts.length} ${t("selected")}`
                : (t("Select products"))}
            </span>
            <DownOutlined
              className={`transition-transform ${showDropdown ? "rotate-180" : ""
                }`}
            />
          </button>

          {showDropdown && (
            <div
                ref={dropdownRef}
              className="absolute z-50 left-0 right-0 bg-white border border-gray-200 rounded-md shadow-lg w-full mt-2 overflow-y-auto p-4 custom-scrollbar"
              style={{ maxHeight: "300px" }}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder={t("Search products...")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="mb-3 text-lg h-12 rounded-md focus:outline-none"
                suffix={
                  searchQuery && (
                    <span
                      onClick={() => setSearchQuery("")}
                      className="cursor-pointer text-gray-400 hover:text-gray-600 text-xl font-semibold"
                    >
                      ×
                    </span>
                  )
                }
              />

              {loading ? (
                <div className="flex justify-center text-lg py-4">
                  <Spin />
                </div>
              ) : (products.length > 0 && searchQuery.length > 1) ? (
                <>
                  {products.map((p) => (
                    <div
                      key={p.prod_id}
                      onClick={() => toggleProduct(p.prod_id)}
                      className={`flex items-center py-2 px-2 rounded-md cursor-pointer hover:bg-green-50 ${selectedProducts.includes(p.prod_id) ? "bg-green-50" : ""
                        }`}
                    >
                      <Checkbox
                        checked={selectedProducts.includes(p.prod_id)}
                        onChange={(e) => {
                          e.stopPropagation();         // prevent row click
                          toggleProduct(p.prod_id);    // toggle when clicking checkbox
                        }}
                        onClick={(e) => e.stopPropagation()} // prevent double toggle
                      >
                        <span className="ms-2 text-gray-800 text-lg">
                          {p.name}
                        </span>
                      </Checkbox>
                    </div>
                  ))}
                </>
              ) : (<>
                 {searchQuery.length > 1 &&
                <p className="text-center text-gray-400 py-4">
                  {t("No products found")}
                </p>}
               </>  
              )}
            </div>
          )}
        </div>
</div>
        {/* Group Name Section */}
  

        {/* Save Button */}
         <div className="flex justify-end gap-4 ">
          <button
            onClick={handleClose}
            className={`px-8 py-2 font-semibold text-lg border rounded-lg bg-white text-[#8DC63F] border-[#8DC63F]`}
          >
            {t("Cancel")}
          </button>
          <button
          onClick={handleSave}
            className={`px-10 py-2 font-semibold text-lg border rounded-lg bg-[#8DC63F] text-white border-[#8DC63F] `}
          >
            {t("Save")}
          </button>
        </div>
        {/* <Button
          block
          className="!h-14 !text-lg !font-semibold !rounded-2xl !bg-[#8DC63F] !text-white hover:!bg-[#7CB82F] hover:!text-white focus:outline-none"
        >
          {t("Save")}
        </Button> */}
      </div>
    </div>
  );
};

export default NewGroup_Modal;
